<div class="switch">
  <input type="checkbox" [attr.id]="id" class="switch__input" [formControl]="control" (change)="changed.emit($event)" />
  <label [attr.for]="id" class="switch__label">Toggle</label>
  <span class="switch__content" [class.switch__content--disabled]="control.disabled">
    <ng-content></ng-content>
  </span>
</div>
